import { ReactNode } from 'react';

import AuthFooter from 'components/cards/AuthFooter';
import AuthCard from './AuthCard';

import AuthBackground from 'assets/images/auth/AuthBackground';

interface Props {
    children: ReactNode;
    withLogo?: boolean;
}

const AuthWrapper = ({ children, withLogo }: Props) => (
    <div className="flex min-h-dvh flex-col">
        <AuthBackground />
        <main className="flex flex-1 items-center justify-center px-4 py-10">
            <AuthCard withLogo={withLogo}>{children}</AuthCard>
        </main>
        <div className="m-6 mt-2">
            <AuthFooter />
        </div>
    </div>
);

export default AuthWrapper;
